import { useEffect, useState } from "react";
import { fetchPublicSettings } from "./api";
import { PHONE_DISPLAY, PHONE2_DISPLAY, EMAIL } from "./site";

let cache: any = null;
let pending: Promise<any> | null = null;

export const useBusinessInfo = () => {
  const [settings, setSettings] = useState<any>(cache);

  useEffect(() => {
    if (cache) return;
    pending =
      pending ||
      fetchPublicSettings()
        .then((r) => {
          cache = r.data;
          return cache;
        })
        .catch(() => ({}));
    pending.then((d) => setSettings(d));
  }, []);

  const biz = settings?.business || {};
  const phone = biz.phone || PHONE_DISPLAY;
  const phone2 = biz.r3_phone2 || PHONE2_DISPLAY;
  const email = biz.email || EMAIL;

  return {
    contactName: biz.contact_name || "Rogelio Tristan",
    r3ContactName: biz.r3_contact_name || "Rogelio Tristan II",
    phone,
    phoneHref: `tel:+1${phone.replace(/\D/g, "")}`,
    smsHref: `sms:+1${phone.replace(/\D/g, "")}`,
    phone2,
    phone2Href: `tel:+1${phone2.replace(/\D/g, "")}`,
    sms2Href: `sms:+1${phone2.replace(/\D/g, "")}`,
    email,
    emailHref: `mailto:${email}`,
    servicesDrywall: biz.services_drywall || [],
    servicesR3: biz.services_r3 || [],
  };
};
